import { OutlinedInput, styled as muiStyled } from "@mui/material";

import styled from "styled-components";

export const StyledOutlined = muiStyled(OutlinedInput)`
    background-color: ${(props) => props.theme.palette.inputColor.main};
    border-radius: 10px;
`;
export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  p {
    margin: 5px 0;
  }
  small {
    color: #f00;
  }
`;
